import config from "@/config";
import http from "@/utils/request";

const api = (path) => `${config.API_URL}${path}`;

export default {
	list: {
		url: api("/admin/live/list"),
		name: "直播列表",
		get(params) {
			return http.get(this.url, params);
		},
	},
	offlineCourseList: {
		url: api("/admin/live/getOfflineCourseList"),
		name: "直播增加-线下课列表",
		get(params) {
			return http.get(this.url, params);
		},
	},
	userList: {
		url: api("/admin/live/userlist"),
		name: "直播开播者/用户列表",
		get(params) {
			return http.get(this.url, params);
		},
	},
	authorizationUsers: {
		url: api("/admin/live/getUserList"),
		name: "直播授权用户列表",
		get(params) {
			return http.get(this.url, params);
		},
	},
	addAuthorization: {
		url: api("/admin/user_lesson/addUserLesson"),
		name: "直播授权",
		post(params) {
			return http.post(this.url, params);
		},
	},
	deleteAuthorization: {
		url: api("/admin/user_lesson/deleteUserLesson"),
		name: "撤销直播授权",
		post(params) {
			return http.post(this.url, params);
		},
	},
	add: {
		url: api("/admin/live/add"),
		name: "新增直播",
		post(params) {
			return http.post(this.url, params);
		},
	},
	detail: {
		url: api("/admin/live/livedata"),
		name: "直播详情",
		post(params) {
			return http.post(this.url, params);
		},
	},
	edit: {
		url: api("/admin/live/edit"),
		name: "编辑直播",
		post(params) {
			return http.post(this.url, params);
		},
	},
	editHistory: {
		url: api("/admin/live/liveLog"),
		name: "直播编辑日志",
		get(params) {
			return http.get(this.url, params);
		},
	},
	delete: {
		url: api("/admin/live/del"),
		name: "删除直播",
		post(params) {
			return http.post(this.url, params);
		},
	},
	status: {
		url: api("/admin/live/status"),
		name: "直播状态更改",
		post(params) {
			return http.post(this.url, params);
		},
	},
	pushConfig: {
		url: api("/ly/media/backApi/liveAdmin/getPushConfig"),
		name: "获取 TRTC 开播推流配置",
		get(params) {
			return http.get(this.url, params);
		},
	},
	statistics: {
		url: api("/ly/media/backApi/liveAdmin/statistics"),
		name: "查询直播数据统计",
		get(params) {
			return http.get(this.url, params);
		},
		export: {
			url: api("/ly/media/backApi/liveAdmin/statistics/export"),
			name: "导出直播场次数据统计",
			post(params, config) {
				return http.post(this.url, params, config);
			},
		},
	},
	auditStatus: {
		url: api("/admin/live/auditStatus"),
		name: "直播审核状态更改",
		post(params) {
			return http.post(this.url, params);
		},
	},
	push: {
		url: api("/admin/live/push"),
		name: "宝贝推送",
		post(params) {
			return http.post(this.url, params);
		},
	},
	redpacket: {
		url: api("/admin/live/redpacket"),
		name: "账户余额",
		post(params) {
			return http.post(this.url, params);
		},
	},
	createLivePacket: {
		url: api("/admin/live/createLivePacket"),
		name: "发红包",
		post(params) {
			return http.post(this.url, params);
		},
	},
	couponApiList: {
		url: api("/admin/live/couponApilist"),
		name: "优惠券选择列表",
		post(params) {
			return http.post(this.url, params);
		},
	},
	couponLinshiApiList: {
		url: api("/admin/live/couponlinshiApilist"),
		name: "临时优惠券选择列表",
		post(params) {
			return http.post(this.url, params);
		},
	},
	addLiveCoupon: {
		url: api("/admin/live/addlivecoupon"),
		name: "添加直播优惠券",
		post(params) {
			return http.post(this.url, params);
		},
	},
	couponList: {
		url: api("/admin/live/couponlist"),
		name: "直播优惠券列表",
		post(params) {
			return http.post(this.url, params);
		},
	},
	couponDelete: {
		url: api("/admin/live/coupondel"),
		name: "删除直播优惠券",
		post(params) {
			return http.post(this.url, params);
		},
	},
	commentList: {
		url: api("/admin/live_comment_list/list"),
		name: "评论列表",
		get(params) {
			return http.get(this.url, params);
		},
	},
	userWatchlist: {
		list: {
			url: api("/admin/live_watch_list/list"),
			name: "用户观看列表",
			get(params, config) {
				return http.get(this.url, params, config);
			},
		},
		options: {
			url: api("/admin/live_watch_list/all"),
			name: "用户观看列表直播标题下拉",
			get(params) {
				return http.get(this.url, params);
			},
		},
	},
	revenueStatistics: {
		list: {
			url: api("/admin/live_statistics/list"),
			name: "直播收入统计列表",
			get(params) {
				return http.get(this.url, params);
			},
		},
		timeinfo: {
			url: api("/admin/live_statistics/timeinfo"),
			name: "直播收入统计按时间查看",
			get(params) {
				return http.get(this.url, params);
			},
		},
		goodsinfo: {
			url: api("/admin/live_statistics/goodsinfo"),
			name: "直播收入统计商品销售明细",
			get(params) {
				return http.get(this.url, params);
			},
		},
	},
	manageGoodsOptions: {
		url: api("/admin/live_manage/getGoodsListWaibao"),
		name: "商品列表",
		get(params) {
			return http.get(this.url, params);
		},
	},
	manageOrderGoodsList: {
		url: api("/admin/live_manage/orderGoodsList"),
		name: "直播管理订单商品列表",
		get(params) {
			return http.get(this.url, params);
		},
	},
	manageList: {
		url: api("/admin/live_manage/list"),
		name: "宝贝列表",
		get(params) {
			return http.get(this.url, params);
		},
	},
	manageAdd: {
		url: api("/admin/live_manage/add"),
		name: "宝贝增加",
		post(params) {
			return http.post(this.url, params);
		},
	},
	manageEdit: {
		url: api("/admin/live_manage/edit"),
		name: "宝贝上下架/删除",
		post(params) {
			return http.post(this.url, params);
		},
	},
	manageSingleEdit: {
		url: api("/admin/live_manage/singleEdit"),
		name: "状态管理",
		post(params) {
			return http.post(this.url, params);
		},
	},
	noticeList: {
		url: api("/admin/live_notice/all"),
		name: "公告列表",
		get(params) {
			return http.get(this.url, params);
		},
	},
	noticeAdd: {
		url: api("/admin/live_notice/add"),
		name: "公告增加",
		post(params) {
			return http.post(this.url, params);
		},
	},
	noticeEdit: {
		url: api("/admin/live_notice/edit"),
		name: "公告开启播放",
		post(params) {
			return http.post(this.url, params);
		},
	},
	liveUserList: {
		url: api("/admin/live_user/list"),
		name: "管理列表",
		get(params) {
			return http.get(this.url, params);
		},
	},
	liveUserAdd: {
		url: api("/admin/live_user/add"),
		name: "新增管理员",
		post(params) {
			return http.post(this.url, params);
		},
	},
	liveUserEdit: {
		url: api("/admin/live_user/edit"),
		name: "编辑管理员",
		post(params) {
			return http.post(this.url, params);
		},
	},
	liveUserDelete: {
		url: api("/admin/live_user/delete"),
		name: "删除管理员",
		post(params) {
			return http.post(this.url, params);
		},
	},
	topUpConfigurationList: {
		url: api("/admin/live_topup/list"),
		name: "充值配置列表",
		get(params) {
			return http.get(this.url, params);
		},
	},
	topUpConfigurationStore: {
		url: api("/admin/live_topup/store"),
		name: "编辑充值配置",
		post(params) {
			return http.post(this.url, params);
		},
	},
	rewardGiftList: {
		url: api("/admin/live_reward_amount_config/list"),
		name: "打赏礼物列表",
		get(params) {
			return http.get(this.url, params);
		},
	},
	rewardGiftStore: {
		url: api("/admin/live_reward_amount_config/store"),
		name: "新增/编辑打赏礼物",
		post(params) {
			return http.post(this.url, params);
		},
	},
	rewardGiftDetail: {
		url: api("/admin/live_reward_amount_config/getDetail"),
		name: "打赏礼物详情",
		get(params) {
			return http.get(this.url, params);
		},
	},
	rewardGiftDelete: {
		url: api("/admin/live_reward_amount_config/del"),
		name: "删除打赏礼物",
		post(params) {
			return http.post(this.url, params);
		},
	},
};
